import FormTipoNiente from "./FormTipoNiente";
export default FormTipoNiente;
